module.exports = __webpack_public_path__ + "img/icon_classify03.c2ed7e44.png";